export default "__VITE_ASSET__B2jO23yf__"